import { Button, Col, Input, message, Popconfirm, Row } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";

function RemoveVisaPersonalFunction(props) {
  const [loading, setLoading] = useState(false);
  const [profileModel, setProfileModel] = useState(testProfile);
  const [messageApi, contextHolder] = message.useMessage();

  // const [row, setRow] = useState('1');
  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('');

  const create = async (profile) => {
    if(!sheetURL || !sheetName) {
      alert("Data GG Sheet chưa nhập !!!")
      return;
    }
    // if(!row && +row <= 0) {
    //   alert("Số dòng chưa nhập !!!")
    //   return;
    // }
    messageApi.info(`Profile: ${profile.name} >>> Remove VISA TKCN...`);
    let body = {
      profile: profile,
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName,
      }
    };
    axios
      .post(`${API_HOST}/api/account/remove-visa-personal`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ add-acct-full ~ e:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetName = localStorage.getItem('re-vi-tkcn-sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('re-vi-tkcn-sheetURL')
    if(sheetURL) {
      setSheetURL(sheetURL)
    }
  }, [])

  const onOpenChange = (open) => {
    if (open) {
      setLoading(true);
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          setLoading(false);
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          setLoading(false);
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Remove VISA TKCN"
        description={
          <div style={{ width: '500px' }}>
            {profileModel?.errorMsg?.length > 0 && (
              <label style={{ color: "red", border: "1px solid red" }}>
                <strong>{profileModel?.errorMsg}</strong>
              </label>
            )}
            {/* <Row>
              <Col span={10}>
                <label>Lấy Data Từ Dòng: </label>
              </Col>
              <Col span={14}>
                <Input
                  value={row}
                  type="number"
                  style={{ width: 60 }}
                  placeholder="Dòng số: 1,2,3 ..."
                  onChange={(e) => setRow(e.target.value)}
                />
              </Col>
            </Row> */}

            <b>Data GG sheet: </b>
            <Row>
              <Col span={2}>
                <label>URL: </label>
              </Col>
              <Col span={22}>
               <Input
                  value={sheetURL}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL(e.target.value);
                    localStorage.setItem('re-vi-tkcn-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={2}>
                <label>Trang: </label>
              </Col>
              <Col span={22}>
                 <Input
                    value={sheetName}
                    style={{ width: 200 }}
                    placeholder="Visa USA..."
                    onChange={(e) => {
                      setSheetName(e.target.value);
                      localStorage.setItem('re-vi-tkcn-sheetName', e.target.value);
                    }}
                  />
              </Col>
            </Row>
          </div>
        }
        onConfirm={() => create(props.profile)}
      >
        <Button danger><b>Remove VISA TKCN</b></Button>
      </Popconfirm>
    </>
  );
}
export default RemoveVisaPersonalFunction;
